import Rule from "../../../common/rule";
import ScoringMode from "../../enums/scoring-mode";

export default class FinalizeEvent extends Rule {
    getPointsToWin(config) {
        const { scoringMode, numberOfMatches } = config;

        return scoringMode === ScoringMode.BestOfSeries.code
            ? 1
            : numberOfMatches;
    }
    // eslint-disable-next-line no-unused-vars
    applicable(gameContext, ruleContext, eventConfiguration, { match }) {
        const { singles, doubles } = eventConfiguration;

        const totalPointsToWin =
            this.getPointsToWin(singles) + this.getPointsToWin(doubles);

        const pointsToWin = totalPointsToWin / 2;

        return (
            gameContext.getVisitorScore() > pointsToWin ||
            gameContext.getHomeScore() > pointsToWin
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(gameContext, ruleContext, eventConfiguration, { match }) {
        if (gameContext.getVisitorScore() > gameContext.getHomeScore()) {
            gameContext.winnerTeamId = gameContext.awayTeamId;
        }
        if (gameContext.getVisitorScore() < gameContext.getHomeScore()) {
            gameContext.winnerTeamId = gameContext.homeTeamId;
        }
    }
}
